import { ApiParams, BaseClient, IActionResponse, IActionResult, IPagedResult } from "../../../assets/utils/lib";
import { CommunityDevelopmentDto, CommunityDevelopmentFavoriteDto, CommunityDevelopmentGridDto, CommunityDevelopmentNoteDto, CommunityDevelopmentReplyDto, LookupDto, SearchCommunityDevelopmentDto, SearchDto } from "../../dto";

export class CommunityDevelopmentClient extends BaseClient {
    routes = ["pophub", "IdeaSuite"];

    async getLookupsAsync(): Promise<{ developmentResponse: LookupDto[]; tags: LookupDto[] }> {
        const actions: string[] = ["GetLookups"];
        const result: { developmentResponse: LookupDto[]; tags: LookupDto[] } = await this.getAsync<{ developmentResponse: LookupDto[]; tags: LookupDto[] }>(actions, []);
        return result;
    }
    async getCommunityDevelopmentAsync(id: string | undefined): Promise<CommunityDevelopmentDto> {
        const actions: string[] = ["GetCommunityDevelopment"];
        const params: ApiParams[] = [new ApiParams("id", id, true)];

        const result: CommunityDevelopmentDto = await this.getAsync<CommunityDevelopmentDto>(actions, params);
        return result;
    }

    async searchCommunityDevelopmentAsync(payload: SearchCommunityDevelopmentDto | undefined): Promise<IPagedResult<CommunityDevelopmentGridDto>> {
        const actions: string[] = ["SearchCommunityDevelopment"];
        const result: IPagedResult<CommunityDevelopmentGridDto> = await this.postAsync<SearchCommunityDevelopmentDto, CommunityDevelopmentGridDto, IPagedResult<CommunityDevelopmentGridDto>>(actions, payload);
        return result;
    }

    async saveCommunityDevelopmentAsync(payload: CommunityDevelopmentDto | undefined): Promise<IActionResult<CommunityDevelopmentDto>> {
        const actions: string[] = ["SaveCommunityDevelopment"];
        return await this.postAsync<CommunityDevelopmentDto>(actions, payload);
    }

    async saveCommunityDevelopmentFavoriteAsync(payload: CommunityDevelopmentFavoriteDto | undefined): Promise<IActionResult<CommunityDevelopmentFavoriteDto>> {
        const actions: string[] = ["SaveCommunityDevelopmentFavorite"];
        return await this.postAsync<CommunityDevelopmentFavoriteDto>(actions, payload);
    }

    async deleteCommunityDevelopmentAsync(id: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteCommunityDevelopment"];
        const params: ApiParams[] = [new ApiParams("id", id, true)];
        return await this.deleteAsync(actions, params);
    }

    async getCommunityDevelopmentNotesAsync(payload: SearchDto | undefined): Promise<IPagedResult<CommunityDevelopmentNoteDto>> {
        const actions: string[] = ["GetCommunityDevelopmentNotes"];
        const result: IPagedResult<CommunityDevelopmentNoteDto> = await this.postAsync<SearchDto, CommunityDevelopmentNoteDto, IPagedResult<CommunityDevelopmentNoteDto>>(actions, payload);
        return result;
    }

    async getCommunityDevelopmentNoteAsync(id: string | undefined): Promise<CommunityDevelopmentNoteDto> {
        const actions: string[] = ["GetCommunityDevelopmentNote"];
        const params: ApiParams[] = [new ApiParams("id", id, true)];

        const result: CommunityDevelopmentNoteDto = await this.getAsync<CommunityDevelopmentNoteDto>(actions, params);
        return result;
    }
    async saveCommunityDevelopmentNoteAsync(payload: CommunityDevelopmentNoteDto | undefined): Promise<IActionResult<CommunityDevelopmentNoteDto>> {
        const actions: string[] = ["SaveCommunityDevelopmentNote"];
        return await this.postAsync<CommunityDevelopmentNoteDto>(actions, payload);
    }

    async deleteCommunityDevelopmentNoteAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteCommunityDevelopmentNote"];
        const params: ApiParams[] = [new ApiParams("id", id, true)];
        return await this.deleteAsync(actions, params);
    }

    async getCommunityDevelopmentRepliesAsync(id: string | undefined): Promise<CommunityDevelopmentReplyDto[]> {
        const actions: string[] = ["GetCommunityDevelopmentReplies"];
        const params: ApiParams[] = [new ApiParams("communityDevelopmentId", id, true)];

        const result: CommunityDevelopmentReplyDto[] = await this.getAsync<CommunityDevelopmentReplyDto[]>(actions, params);
        return result;
    }

    async saveCommunityDevelopmentReplyAsync(payload: CommunityDevelopmentReplyDto | undefined): Promise<IActionResult<CommunityDevelopmentReplyDto>> {
        const actions: string[] = ["SaveCommunityDevelopmentReply"];
        return await this.postAsync<CommunityDevelopmentReplyDto>(actions, payload);
    }
}